module.exports = __webpack_public_path__ + "static/ga-3e75bdaa643a732a6f39ad3b52b9fe31.png";